export type ConsentStatus = "accepted" | "rejected" | "undecided";

const STORAGE_KEY = "cookie-consent";

export function getConsentStatus(): ConsentStatus {
  if (typeof window === "undefined") {
    return "undecided";
  }

  try {
    const value = localStorage.getItem(STORAGE_KEY);
    if (value === "accepted") {
      return "accepted";
    }
    if (value === "rejected") {
      return "rejected";
    }
  } catch {
    return "undecided";
  }

  return "undecided";
}

export function setConsentStatus(status: "accepted" | "rejected"): void {
  if (typeof window === "undefined") {
    return;
  }

  try {
    localStorage.setItem(STORAGE_KEY, status);
  } catch {
    // Ignore blocked storage writes and fall back to in-memory banner state.
  }
}
